import { z } from 'zod';

export type AuctionUpdateForm = {
    start_date: string,
    end_date: string,
    start_price: number,
};

export type AuctionUpdateFormErrors = {
    start_date?: string[],
    end_date?: string[],
    start_price?: string[],
};

export const AuctionUpdateFormErrorsSchema = z.object({
    start_date: z.string().array().optional(),
    end_date: z.string().array().optional(),
    start_price: z.string().array().optional(),
});
